module.exports = __webpack_public_path__ + "img/i-role-min5.7a1f2118.png";